import { appConfig as $config } from '../app.config';
import { User } from './User';
import { App } from './App';
import { UI } from './UI';

export const Common = (function () {
  const mapping = {
    approvalObject: (data) => {
      data = data || { approvedName: 'Default' };
      if (!data.approvals) {
        return data;
      }
      const statusNames = $config.approveTypeName;

      let approveStatus = [],
        approveDisplayData = [];
      data.approvals.forEach((obj) => {
        obj.title = `${obj.userGroup.title} ${
          obj.approveType === statusNames.approved ? $Lang.common.Approval : $Lang.common.Rejection
        }`;
        obj.created = `${moment(obj.approveDate).format($config.appFullDateFormat)}, by ${obj.user?.accountName || ``}`;
        if (approveDisplayData[obj.approveType]) approveDisplayData[obj.approveType].push(obj);
        else approveDisplayData[obj.approveType] = [obj];
      });

      Object.keys(statusNames).forEach((name) => {
        if (approveDisplayData[statusNames[name]]) {
          approveStatus[statusNames[name]] = {
            title:
              name === 'default'
                ? $Lang.common.ApprovalUnspecified
                : name === 'approved'
                ? $Lang.common.Approval
                : $Lang.common.Rejection,
            count: name === 'default' ? '' : approveDisplayData[statusNames[name]].length
          };
        }
      });

      // Remove Default if need
      if (approveStatus[statusNames.approved] || approveStatus[statusNames.disapproved]) {
        delete approveStatus[statusNames.default];
      }
      delete approveDisplayData[statusNames.default];

      // Sort popover data
      approveDisplayData = Object.keys(approveDisplayData)
        .sort()
        .reduce((acc, key) => ({ ...acc, [key]: approveDisplayData[key] }), {});

      return {
        ...data,
        ...{
          approveDisplayData,
          approveStatus
        }
      };
    }
  };

  let init = () => {
    storageInit();

    // Debounce
    debonceInit();

    validationRuleMethods();

    dataTableDefaultsInit();
  };

  const dataTableDefaultsInit = () => {
    $.extend(true, $.fn.dataTable.defaults, {
      preDrawCallback: function (settings) {
        const api = new $.fn.dataTable.Api(settings);

        const pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');

        pagination.toggle(api.page.info().pages > 1);

        UI.block('#page');
      },
      drawCallback: function () {
        UI.unblock('#page');
      }
    });
  };

  let validationRuleMethods = () => {
    jQuery.validator.addMethod(
      'zipcode',
      function (value, element) {
        return this.optional(element) || /^\d{5}(?:-\d{4})?$/.test(value);
      },
      'Please provide a valid zipcode.'
    );

    jQuery.validator.addMethod(
      'phone',
      function (value, element) {
        return this.optional(element) || /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/.test(value);
      },
      'Please provide a valid zipcode.'
    );

    jQuery.validator.addMethod(
      'notEqualToGroup',
      function (value, element, options) {
        var elems = $(element).parents('form').find(options[0]);
        var valueToCompare = value;
        var matchesFound = 0;
        jQuery.each(elems, function () {
          var thisVal = $(this).val();
          if (thisVal === valueToCompare) {
            matchesFound++;
          }
        });
        if (this.optional(element) || matchesFound <= 1) {
          return true;
        } else {
          elems.addClass('error');
        }
      },
      'Please enter a Unique Value.'
    );
  };

  let storageInit = () => {
    Storages.alwaysUseJsonInStorage(true);
    window['$storage'] = Storages.localStorage;
  };

  let paginationDialog = ({ paginationWraper = false, pagename = false, action = () => {} } = {}) => {
    if (!paginationWraper) return;
    if (pagename) {
      $storage.remove('pagepage_' + pagename);
    }

    //$('.kt-pagination a[data-navigo]', $(paginationWraper)).off();
    $('.kt-pagination a[data-navigo]', $(paginationWraper)).each(function () {
      $(this).attr('href', 'javascript:');
      $(this)
        .off()
        .on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          let target = $(e.target.closest('a'));
          let pagename = target.data('pagename');
          let page = target.data('page');
          if (pagename && page) {
            $storage.set('pagepage_' + pagename, page);
          }
          action();
          return false;
        });
    });
  };

  let paginationParams = (pagename = false, query = '', ...otherValues) => {
    var uri = segmentedURI();
    var obj = {
      page: getQueryVal('page', query) || 1,
      pageLimit: $config.paging.pagelimit[pagename] || $config.paging.pagelimit.default,
      filters: JSON.stringify([
        {
          item: {
            searchColumn: KTUtil.getParameterByName('?searchColumn', query) || '',
            searchValue: KTUtil.getParameterByName('searchValue', query) || ''
          }
        },
        {
          item: {
            searchColumn: 'categories',
            searchValue: KTUtil.getParameterByName('?categories', query) || ''
          }
        },
        {
          item: {
            searchColumn: 'brands',
            searchValue: KTUtil.getParameterByName('?brands', query) || ''
          }
        }
      ]),
      sortItems: JSON.stringify([{ sortColumn: KTUtil.getParameterByName('orderBy', query) || '' }]),
      requestPage: uri.page == '' ? $config.default.page : uri.page
    };

    for (let i = 0; i < otherValues.length; i++) {
      var value = KTUtil.getParameterByName(otherValues[i], query);
      if (value != null) {
        obj[otherValues[i]] = value;
      }
    }
    return obj;
  };

  let pageQueryParams = (pagename = false, query = '') => {
    let uri = segmentedURI();
    let requestPage = pagename ? pagename : uri.page != '' ? uri.page : $config.default.page;
    let sorting = $storage.isSet('sortingpage_' + requestPage) ? $storage.get('sortingpage_' + requestPage) : false;
    if (sorting) delete sorting['value'];
    let obj = {
      page: getQueryVal('page', query) || 1,
      pageLimit: $config.paging.pagelimit[pagename] || $config.paging.pagelimit.default,
      filters: [],
      sortItems: sorting ? [sorting] : [],
      requestPage: requestPage,
      accountId: User.accountID()
    };

    return obj;
  };

  let paginationData = ({ pageLimit = false, totalCount = false, page = false } = {}) => {
    if (!totalCount || !pageLimit) return false;

    return {
      totalCount: totalCount,
      total: Math.ceil(totalCount / pageLimit),
      page: page
    };
  };

  let segmentedURI = () => {
    let path = document.location.href.split('/');
    return {
      page: path[path.length - 1].indexOf('index') < 0 ? path[path.length - 1].split('?')[0] : '',
      query: path[path.length - 1].split('?')[1] ? path[path.length - 1].split('?')[1] : false
    };
  };

  /**
   * Prepare response data for All pages
   * @param {Object} data - Response data
   * @return {Object} prepared data
   */
  let responsePrepare = (data = false) => {
    if (!data) return;
    //let url = document.location.pathname.split('/');
    // TODO check
    //if(url[2] || !$config.filter.pages.includes(url[1]) ) return data;

    if (data.totalCount !== null) App.pageData('totalCount', '0');

    if (!data.totalCount && data.totalCount !== 0) {
      return data;
    }
    App.pageData('totalCount', data.totalCount);
    let pagename = data.requestPage
      ? data.requestPage
      : document.location.pathname.split('/')[1]
      ? document.location.pathname.split('/')[1]
      : $config.routing.startpage;

    let pageLimit = $config.paging.pagelimit[pagename] || $config.paging.pagelimit.default;

    let page = Common.gup('page');
    if (data.page !== undefined) {
      page = data.page;
      //$storage.set('pagepage_'+pagename, page);
      delete data['page'];
    } else if (!page) {
      page = $storage.isSet('pagepage_' + pagename) ? $storage.get('pagepage_' + pagename) : 1;
    }

    let out = {
      ...data,
      $lang: $Lang,
      pagination: {
        pagename: pagename,
        page: page,
        totalCount: data.totalCount,
        total: Math.ceil(data.totalCount / pageLimit)
      }
    };

    return out;
  };

  // Add restoreQuery to query params (eg "/listings?restoreQuery") - Restore catalog page number
  let restoreQuery = () => {
    let url = document.location.pathname.split('/');
    if (!url[2]) {
      let pagename = url[1];
      let pageGup = gup('page');
      let restoreGup = gup('restoreQuery');
      if (!pageGup && restoreGup === null) {
        $storage.remove('pagepage_' + pagename);
      } else {
        if (restoreGup !== null) {
          if ($storage.isSet('pagequery_' + pagename)) {
            window.history.replaceState(
              null,
              '',
              `${document.location.pathname}${$storage.get('pagequery_' + pagename)}`
            );
            $storage.remove('pagequery_' + pagename);
            return;
          }

          let page = $storage.get('pagepage_' + pagename);
          if (page) {
            window.history.replaceState(null, '', `${document.location.pathname}?page=${page}`);
          } else {
            window.history.replaceState(null, '', `${document.location.pathname}`);
          }
        } else if (pageGup) {
          $storage.set('pagepage_' + pagename, Common.gup('page'));
        }
      }
    }
  };

  /**
   * return get parameter value
   * @param {String} name name of get parameter
   * @param {String} str query string
   * @return {String} value of parameter
   */
  let getQueryVal = (name, str) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regexS = name + '=([^&#]*)'; //"[\\?&]"+
    let regex = new RegExp(regexS);
    let results = regex.exec(str);
    if (results == null) return false;
    else return results[1];
  };

  /**
   * set value of parameters and return query string
   * @param {String} query current query
   * @param {String} params array of params { key: paramName, value: paramValue }
   * @return {String} updated query
   */
  let setQueryValues = (query, ...params) => {
    if (query === false) {
      query = '?';
      for (let i = 0; i < params.length; i++) {
        let paramName = params[i].key;
        let paramVal = params[i].value;
        if (i !== 0) {
          query = `${query}&${paramName}=${paramVal}`;
        } else {
          query = `${query}${paramName}=${paramVal}`;
        }
      }

      return query;
    }

    query = `?${query}`;
    for (let i = 0; i < params.length; i++) {
      let paramName = params[i].key;
      paramName = paramName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      let paramVal = params[i].value;
      if (query.indexOf(paramName) > -1) {
        let regexS = paramName + '=([^&#]*)';
        let regex = new RegExp(regexS);
        let results = regex.exec(query);
        let oldVal = results[1];
        if (paramVal == undefined || paramVal.length == 0) {
          let indexOfName = query.indexOf(oldVal);
          if (indexOfName + oldVal.length + 1 <= query.length) {
            query = query.substr(0, indexOfName + oldVal.length) + query.substr(indexOfName + oldVal.length + 1);
          }
          query = query.replace(`${paramName}=${oldVal}`, '');
          if (query == '?' || query == '&') {
            query = '';
          }
        } else {
          query = query.replace(oldVal, paramVal);
        }
      } else {
        query = `${query}&${paramName}=${paramVal}`;
      }
    }

    return query;
  };

  let removeQueryValues = (sParam, str) => {
    let url = str.split('?')[0] + '?';
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] != sParam) {
        url = url + sParameterName[0] + '=' + sParameterName[1] + '&';
      }
    }
    return url.substring(0, url.length - 1);
  };

  let addQuerySearchParams = (params = [], url = document.location.href) => {
    // create a URL object
    const urlObj = new URL(url);
    // initialize URLSearchParams
    let urlParams = new URLSearchParams(urlObj.search);

    params = Array.isArray(params) ? params : [params];
    for (let i = 0; i < params.length; i++) {
      urlParams.append(params[i].key, params[i].value);
    }
    urlObj.search = urlParams;
    return urlObj.toString();
  };

  let uniqID = () =>
    Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substr(2, 10);

  let isNumberKey = (e) => {
    var val = $(e).val();
    if (isNaN(val)) {
      val = val.replace(/[^0-9\.]/g, '');
      if (val.split('.').length > 2) val = val.replace(/\.+$/, '');
    }
    $(e).val(val);
  };

  let guidGenerator = () => {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
  };

  let gup = (param) => {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) !== '' ? urlParams.get(param) : false;
  };

  // Debounce
  let debonceInit = () => {
    let debounce = function (func, threshold, execAsap) {
      let timeout;

      return function debounced() {
        let obj = this,
          args = arguments;

        function delayed() {
          if (!execAsap) func.apply(obj, args);
          timeout = null;
        }

        if (timeout) clearTimeout(timeout);
        else if (execAsap) func.apply(obj, args);

        timeout = setTimeout(delayed, threshold || 250);
      };
    };
    jQuery.fn['smartkeyup'] = function (fn) {
      return fn ? this.bind('keyup', debounce(fn)) : this.trigger('smartkeyup');
    };
  };

  let select2focus = (e) => {
    setTimeout(() => {
      $('.select2-search__field', $(e.target).siblings('.select2')).focus();
    }, 50);
  };

  let sizeRange = (arr = []) => {
    let nArr = [];
    arr.filter((i) => i.select).forEach((j) => nArr.push(j.size));
    return nArr.join(', ');
  };

  let priceRange = (range = {}) => {
    if (!range.minPrice) {
      return '';
    }
    let min =
      range.minPrice && range.minPrice.currencyCode
        ? $config.currencySymbol[range.minPrice.currencyCode] + '' + range.minPrice.currencyValue.toFixed(2)
        : '';
    let max =
      range.maxPrice && range.maxPrice.currencyCode
        ? $config.currencySymbol[range.maxPrice.currencyCode] + '' + range.maxPrice.currencyValue.toFixed(2)
        : '';
    return range.minPrice.currencyValue == range.maxPrice.currencyValue ? min : `${min} - ${max}`;
  };

  let currencySymbolByCode = (code) => {
    return `${$config.currencySymbol[code]} ${code}`;
  };

  let fileType = (name) => {
    name = name.split('.');
    let ext = name[name.length - 1].toLowerCase();
    let type;
    switch (ext) {
      case 'ai':
        type = 'ai';
        break;
      case 'pdf':
        type = 'pdf';
        break;
      case 'psd':
        type = 'psd';
        break;
      case 'tif':
        type = 'tif';
        break;
      case 'tiff':
        type = 'tif';
        break;
      case 'svg':
        type = 'svg';
        break;
      case 'png':
        type = 'image';
        break;
      case 'jpg':
        type = 'image';
        break;
      case 'jpeg':
        type = 'image';
        break;
      case 'gif':
        type = 'image';
        break;
      case 'ttf':
        type = 'font';
        break;
      case 'otf':
        type = 'font';
        break;
      case 'eot':
        type = 'font';
        break;
      case 'woff':
        type = 'font';
        break;
      case 'woff2':
        type = 'font';
        break;
      default:
        type = 'other';
    }
    return type;
  };

  let _uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const slugify = (text) => {
    return (
      text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        //.toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '_')
    );
  };

  let inchToCm = (number) => {
    return Math.round((parseFloat(number).toFixed(2) * 2.54 + Number.EPSILON) * 100) / 100;
  };

  let cmToInch = (number) => {
    return Math.round((parseFloat(number).toFixed(2) / 2.54 + Number.EPSILON) * 100) / 100;
  };

  let saveFile = (url, filename = '') => {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop();
    }

    let xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
      let a = document.createElement('a');
      a.href = window.URL.createObjectURL(xhr.response);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.parentNode.removeChild(a);
      UI.unblockPage();
    };
    xhr.open('GET', url);
    xhr.send();
  };

  let fixedEncodeURI = (str) => {
    return encodeURI(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  };

  return {
    init,
    mapping,
    paginationDialog,
    paginationParams,
    pageQueryParams,
    paginationData,
    responsePrepare,
    restoreQuery,
    segmentedURI,
    getQueryVal,
    gup,
    setQueryValues,
    removeQueryValues,
    addQuerySearchParams,
    uniqID,
    isNumberKey,
    guidGenerator,
    select2focus,
    sizeRange,
    priceRange,
    currencySymbolByCode,
    fileType,
    _uuidv4,
    slugify,
    inchToCm,
    cmToInch,
    saveFile,
    fixedEncodeURI
  };
})();
